import React from 'react';
import styled from 'styled-components';

import { useL10n } from '^/hooks';
import Text from './text';
import { HorizontalLine } from '^/components/atoms/HorizontalLine';

const TextLabel = styled.div({
  color: '#9FA19C',
  textAlign: 'center',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
  marginTop: '10px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  whiteSpace: 'nowrap',
});

export function SignInWithDivider() {
  const [l10n] = useL10n();
  return (
    <TextLabel>
      <HorizontalLine />
      {l10n(Text.authDividerLabel)}
      <HorizontalLine />
    </TextLabel>
  );
}
